import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import LoadingImg from "./loading_animation_original.gif";

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkLoading() {
    return Object.values(this.props.loadingReducer).every(x => x === false);
  }

  render() {
    return (
      !this.checkLoading() && (
        <ImageDiv>
          <img src={LoadingImg} alt="Loader" />
          <InnerDiv />
        </ImageDiv>
      )
    );
  }
}

const ImageDiv = styled.div`
  //
  height: 100%;
  width: 100%;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  && img {
    z-index: 101;
    position: absolute;
    top: 50%;
    margin-top: -170px;
    margin-left: -150px;
  }
`;

const InnerDiv = styled.div`
    height:100%;
    width:100% ;
    background-color:white;
    position:absolute
    opacity: .5;
    top:0;
    left:0;
    //
`;

const mapStateToProps = ({ loadingReducer }) => {
  return {
    loadingReducer
  };
};

export default connect(mapStateToProps)(Loading);
